//import { callApi, createGql, getAllFormColumns, ErrorAlert } from '../crud/utils';
import { callApi, createGql,getAllFormColumns } from '../crud/utils';
// import { format  } from 'date-fns';
import dayjs from "dayjs";
dayjs.locale('el');

export async function loadData(serverUrl, userToken, objectName, columns, additionalColumns, prms, prmValues, defaultVariables) {
    const requestBody = createGql(objectName, columns, additionalColumns, prms, prmValues, defaultVariables);
    let url = `${serverUrl}/api/query`;
    const gqlResult = await callApi('POST', url, userToken, requestBody);
    return gqlResult.data[objectName];
}
export async function loadListObject(serverUrl, userToken, objectName) {
    if (!serverUrl) return;
    let url = `${serverUrl}/api/layouts/list/${objectName}`
    return await callApi('GET', url, userToken);
}
export async function loadDataObject(serverUrl, userToken, objectName, allobjectcolumns, prms, prmValues, defaultVariables) {
    let allCol = {};
    if (Object.keys(allobjectcolumns?.[objectName]?.columns || {}).length === 0) {
        allCol = await loadListObject(serverUrl, userToken, objectName);
    }
    else {
        allCol = allobjectcolumns[objectName];
    }
    let additionalColumns = allCol.primaryKey;
    return await loadData(serverUrl, userToken, objectName, allCol.columns, additionalColumns, prms, prmValues, defaultVariables)
}
export async function getIsHoliday(serverUrl, userToken,currentDate) {
    if (!serverUrl) return;
    // let url = `${serverUrl}/api/Booking/IsHoliday?checkDate=${format(currentDate, "yyyy-MM-dd'T'HH:mm")}`
    // return await callApi('GET', url, userToken);
    // Εχει φτιαχτει ετσι μεχρι να υλοποιηθει στο backend για την δηλωση ημερων 
    return false; 
}

export async function loadListAllObjects(serverUrl, userToken) {
    let loadAllObjects = {};
    let objectName = "Yms_Warehouses";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_Booking";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_BookingSuppliers";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_BookingTasks";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_Users";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_Porders";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_Trucks";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_Drivers";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_Suppliers";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_Zones";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_Tasks";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    objectName = "Yms_3plSuppliers";
    loadAllObjects[objectName] = await loadListObject(serverUrl, userToken, objectName);
    return loadAllObjects;
}

export async function loadFormObject(serverUrl, userToken, objectName) {
    if (!serverUrl) return;
    let url = `${serverUrl}/api/layouts/Form/${objectName}`
    return await callApi('GET', url, userToken);
}


export async function loadEditObject(serverUrl, userToken,listLayout, prms, prmValues, defaultVariables){
    const formLayout = await loadFormObject(serverUrl, userToken, listLayout.layoutId);
    if (formLayout){
       // let pkColumnNames = [];
        let editModeColumnNames = [];    
      //  pkColumnNames = listLayout.primaryKey;
        const listColNames = listLayout.columns.filter(col => col.controlType !== "List").map(col => col.columnName);
        editModeColumnNames = [...editModeColumnNames, ...listColNames];
        editModeColumnNames = [...editModeColumnNames, ...listLayout.primaryKey.filter(a => !editModeColumnNames.includes(a))];
        editModeColumnNames = [...editModeColumnNames, ...listLayout.additionalColumns.filter(a => !editModeColumnNames.includes(a))];
        if (formLayout) {
            editModeColumnNames = getAllFormColumns(formLayout, editModeColumnNames);
        }    
        const requestBody = createGql(listLayout.layoutId, [], editModeColumnNames, prms, prmValues, defaultVariables);
        let url = `${serverUrl}/api/cacheObject`;
        return await callApi('POST', url, userToken, requestBody);
    }
//    const requestBody = createGql(objectName, [], editModeColumnNames, [], [], { createNewRow: true, dontCash, instanceName, parentSelectedRow });
//    const request_Body = createGql(objectName, columns, additionalColumns, prms, prmValues, defaultVariables);
//const requestBody = createGql(objectName, [], editModeColumnNames, [], [], { createNewRow: true, dontCash, instanceName, parentSelectedRow });



}


export async function getBookingSuppliers(serverUrl,userToken,listLayout, BookingId){
    let objectName = "Yms_BookingSuppliers";
    let defaultVariables = {
        "instanceName":"m_yms_booking",
        "filterName": "customfilter",
        "top": 50
    }
    let prms = [];
    let prmValues = {};
    defaultVariables["appendFilter"] = "{YmsBsu.BookingId} =?(;n;15;p_BookingId) ";
    prms.push({ "parameterName": "p_BookingId", "type": "" });
    prmValues["p_BookingId"] = BookingId;
    return await loadDataObject(serverUrl, userToken, objectName, listLayout[objectName], prms, prmValues, defaultVariables);
}
export async function getPorders(serverUrl,userToken,listLayout, BookingId){
    let objectName = "Yms_Porders";
    let defaultVariables = {
        "filterName": "customfilter",
        "top": 50
    }
    let prms = [];
    let prmValues = {};
    defaultVariables["appendFilter"] = "{YmsPor.PoId} in ( " +
        " select tmp.PoId from Yms_BookingSuppliers tmp " +
        " where tmp.BookingId =?(;n;15;p_BookingId))";
    prms.push({ "parameterName": "p_BookingId", "type": "" });
    prmValues["p_BookingId"] = BookingId;
    return await loadDataObject(serverUrl, userToken, objectName, listLayout[objectName], prms, prmValues, defaultVariables);
}
export async function getSuppliers(serverUrl,userToken,listLayout, BookingId){
    let objectName = "Yms_Suppliers";
    let defaultVariables = {
        "filterName": "customfilter",
        "top": 50
    }
    let prms = [];
    let prmValues = {};
    defaultVariables["appendFilter"] = "{YmsSup.SupplierId} in ( " +
        " select tmp.SupplierId from Yms_BookingSuppliers tmp " +
        " where tmp.BookingId =?(;n;15;p_BookingId))";
    prms.push({ "parameterName": "p_BookingId", "type": "" });
    prmValues["p_BookingId"] = BookingId;
    return await loadDataObject(serverUrl, userToken, objectName, listLayout[objectName], prms, prmValues, defaultVariables);
}

export async function getBookingTasks(serverUrl,userToken,listLayout, BookingId){
    let objectName = "Yms_BookingTasks";
    let defaultVariables = {
        "filterName": "customfilter",
        "instanceName":"m_yms_booking",
        "top": 50
    }
    let prms = [];
    let prmValues = {};
    defaultVariables["appendFilter"] = "{YmsBta.BookingId} =?(;n;15;p_BookingId) ";
    prms.push({ "parameterName": "p_BookingId", "type": "" });
    prmValues["p_BookingId"] = BookingId;
    return await loadDataObject(serverUrl, userToken, objectName, listLayout[objectName], prms, prmValues, defaultVariables);
}

export async function getDropdownLookupList(serverUrl,userToken,layout){
    if (layout){
       const foreignCols = layout.tabs.map(tab => tab.columns)
                      .reduce((prev, current) => prev ? prev.concat(current) : current)
                      .filter(col => col.controlType === "DropDownLookUpList");    
       let tmpLookUpInfo = {}, tmpForeignKeyFields = [];
        for (let i = 0; i < foreignCols.length; i++) {
            const gqlResult = await callApi('POST', `${serverUrl}/api/query`, userToken,
                { query: foreignCols[i].lookUpQuery, vars: {} });
            tmpLookUpInfo[foreignCols[i].columnName] = {
                "values": gqlResult.data[Object.keys(gqlResult.data)[0]],
                "keyFields": foreignCols[i].keyFields,
                "column":foreignCols[i]
            };
            tmpForeignKeyFields = tmpForeignKeyFields.concat(foreignCols[i].keyFields.map(k => k.foreignField));
        }
       return tmpLookUpInfo;
    }
    return null;
}



export async function postBooking(serverUrl,userToken,objectName, instancename, currentObj){

       const instanceName =instancename;
        let url = `${serverUrl}/api/Booking`;
        const requestBody = {
            objectName,
            instanceName,
            obj: currentObj
        }
        const result = await callApi('POST', url,userToken,requestBody);
      return result;  
}
export async function putBooking(serverUrl,userToken,objectName, instancename, currentObj){

    const instanceName =instancename;
     let url = `${serverUrl}/api/Booking`;
     const requestBody = {
         objectName,
         instanceName,
         obj: currentObj
     }
     const result = await callApi('PUT', url,userToken,requestBody);
   return result;  
}
export async function DeleteBooking(serverUrl,userToken,objectName, instancename, currentObj){

    const instanceName =instancename;
     let url = `${serverUrl}/api/Booking`;
     const requestBody = {
         objectName,
         instanceName,
         obj: currentObj
     }
     const result = await callApi('DELETE', url,userToken,requestBody);
   return result;  
}


/*
export function getDropDownEnumList(layout){
    if (layout){
       const dropDownEnumList = layout.tabs.map(tab => tab.columns)
       .reduce((prev, current) => prev ? prev.concat(current) : current)
       .filter(col => col.controlType === "DropDownLookUpList");    


    }
    return null;
} */



/* ---- */

export async function loadFormObjectBooking(serverUrl, userToken) {
    let formObject = {}
    let objectName = "Yms_Booking";
    formObject[objectName] = await loadFormObject(serverUrl, userToken, objectName);
    objectName = "Yms_BookingTasks";
    formObject[objectName] = await loadFormObject(serverUrl, userToken, objectName);
    objectName = "Yms_BookingSuppliers";
    formObject[objectName] = await loadFormObject(serverUrl, userToken, objectName);
    return formObject;
}


function extractFieldsFromLookupQuery(lookupQuery) {
    const match = lookupQuery.match(/\{[^{}]+\{([^}]+)\}\}/);
    if (!match) return [];
    return match[1].trim().split(/\s+/);
}

export function getAllColums(object) {
    // Συγκεντρώνουμε όλες τις στήλες από όλα τα tabs
    const allColumns = object.tabs.flatMap(tab => tab.columns);
    // Εξάγουμε όλα τα columnName
    const columnNames = allColumns.map(col => col.columnName);
    // Εξάγουμε όλα τα foreignField από τα keyFields
    const foreignFields = allColumns.flatMap(col =>
        col.keyFields ? col.keyFields.map(kf => kf.foreignField) : []
    );
    // Εξάγουμε όλα τα secondaryColumnName για τα πεδία με controlType: "AutoCompleteLookUp"
    const secondarylookupFields = allColumns
        .filter(col => col.controlType === "AutoCompleteLookUp")
        .flatMap(col => [
            (col.secondaryColumnName ? col.secondaryColumnName : []),
            ...(col.lookUpQuery ? extractFieldsFromLookupQuery(col.lookUpQuery)
                .filter(f => f !== col.columnName?.split('.')[1] && f !== col.secondaryColumnName?.split('.')[1]) : []
            )
        ]);
    // Συνδυάζουμε όλα τα πεδία σε ένα σύνολο για να αποφύγουμε διπλότυπα
    const allFieldsSet = new Set([...columnNames, ...foreignFields, ...secondarylookupFields]);
    // Μετατρέπουμε το σύνολο σε πίνακα
    const allFieldsArray = Array.from(allFieldsSet);
    return allFieldsArray;
}



